module.exports = __webpack_public_path__ + "4da77b98246f57583891874b35efd107.ttf";